import { render, staticRenderFns } from "./medscape.vue?vue&type=template&id=da693a70&scoped=true&v-once=true"
import script from "./medscape.vue?vue&type=script&lang=js"
export * from "./medscape.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da693a70",
  null
  
)

export default component.exports